var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-info-availability" },
    [
      _c(
        "div",
        { staticClass: "head" },
        [
          _c("h1", { staticClass: "title" }, [
            _vm._v(
              "\n      Доступно в " +
                _vm._s(_vm.filteredByMetro.length || "") +
                " " +
                _vm._s(
                  _vm._f("decl")(_vm.filteredByMetro.length, "магазин", [
                    "е",
                    "ах",
                    "ах"
                  ])
                ) +
                " города\n      "
            ),
            _c(
              "span",
              {
                staticClass: "product-info-availability__change-city",
                on: { click: _vm.changeCity }
              },
              [_vm._v("\n        " + _vm._s(_vm.CITY.name) + "\n      ")]
            )
          ]),
          _c("ui-segmented", {
            staticClass: "tabs",
            attrs: { labels: Object.values(_vm.viewTypes) },
            model: {
              value: _vm.view,
              callback: function($$v) {
                _vm.view = $$v
              },
              expression: "view"
            }
          }),
          _c("availability-filter", {
            ref: "availability-filter",
            attrs: {
              "metro-specs": _vm.metroSpecs,
              "is-in-store": _vm.isInStore
            },
            on: {
              change: function($event) {
                _vm.metro = $event
              },
              "in-store-change": function($event) {
                _vm.isInStore = $event
              },
              update: _vm.onUpdateFilters
            }
          })
        ],
        1
      ),
      _vm.ACTIVE_SKU.id
        ? _c(
            "div",
            { staticClass: "stores" },
            [
              _vm.view === _vm.viewTypes.list
                ? _c(
                    "div",
                    [
                      _vm.filteredByMetro.length
                        ? _c(
                            "div",
                            { staticClass: "availability-list" },
                            [
                              _c("vue-client-only", [
                                !_vm.adaptive.isMobile
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "legend availability-grid"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "availability-grid__address"
                                          },
                                          [_vm._v("Адрес")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "availability-grid__delay"
                                          },
                                          [_vm._v("Наличие")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "availability-grid__can-pickup "
                                          },
                                          [_vm._v("Можно забрать")]
                                        ),
                                        _c("span", {
                                          staticClass: "availability-grid__end"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._l(_vm.filteredByMetro, function(store) {
                                return _c("availability-list-item", {
                                  key: store.id,
                                  attrs: { info: store },
                                  on: { "add-to-cart": _vm.onAddToCartInList }
                                })
                              })
                            ],
                            2
                          )
                        : _c("page-info", {
                            staticClass: "page-info",
                            attrs: {
                              title: "По вашему запросу нет доступных магазинов"
                            }
                          })
                    ],
                    1
                  )
                : _c("stores-map", {
                    staticClass: "availability-map",
                    attrs: {
                      "popup-by-click": "",
                      "cart-button-is-active": "",
                      "active-store-id": _vm.activeStoreId,
                      stores: _vm.filteredByMetro
                    },
                    on: { change: _vm.onChangeActiveStoreId }
                  })
            ],
            1
          )
        : _c("page-info", {
            staticClass: "page-info",
            attrs: {
              title:
                "Для поиска товара в магазинах розничной сети необходимо выбрать размер"
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }